import { clearActivePatient } from '@/hooks/useActivePatient';

// Keys match the hooks that own them. useDateRange imports the API layer, which
// imports the auth store, so importing the hooks here would create a cycle.
const PATIENT_LIST_FILTERS_KEY = 'ui.patientListFilters';
const MEAL_FEEDBACK_KEY = 'clinician.mealFeedback.v1';
const DATE_RANGE_KEY_PREFIX = 'patient.dateRange.v3.';

const safely = (action: () => void) => {
  try {
    action();
  } catch {
    // Private mode or blocked storage: nothing to clear.
  }
};

const clearDateRangeKeys = () => {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key?.startsWith(DATE_RANGE_KEY_PREFIX)) keys.push(key);
  }
  keys.forEach((key) => localStorage.removeItem(key));
};

/** Remove browser state tied to patients or to the clinician who held the session. */
export const clearSessionLocalState = () => {
  clearActivePatient();
  safely(() => sessionStorage.removeItem(PATIENT_LIST_FILTERS_KEY));
  safely(() => localStorage.removeItem(MEAL_FEEDBACK_KEY));
  safely(clearDateRangeKeys);
};
